export default {
  setInterviewPolicies(state, payload) {
    state.interviewPolicies = payload;
  },
  setAllDifferentPolicies(state, payload) {
    state.allDifferentPolicies = payload;
  },
};
